import { store, observable, loading } from '~/common/mobx.decorator'
import { action, computed } from 'mobx'
import axios from 'axios'

@store()
class StateSearchStore {
	@observable states = []
	@observable selectedCountry = null
	@observable isLoading = false

	constructor() {
		this.name = 'StateSearchStore'
	}

	@computed
	get dataSource() {
		return this.states.map((item) => ({
			label: item.name,
			value: item.state_code,
		}))
	}

	@loading
	@action
	fetchStates = async (countryCode) => {
		if (!countryCode) {
			this.states = []
			return []
		}

		try {
			this.isLoading = true
			const response = await axios.get(`/api/public/v1/states`, {
				params: {
					'countryCodes[]': countryCode,
				},
			})

			const statesData = response?.data || []
			// Normalize to array of { id, name }
			this.states = statesData

			return this.states
		} catch (error) {
			console.error('Error fetching states:', error)
			this.states = []
			return []
		} finally {
			this.isLoading = false
		}
	}

	@action
	setCountry = (countryCode) => {
		this.selectedCountry = countryCode
		// Reset states when country changes
		this.states = []
		// Fetch states for the new country
		if (countryCode) {
			this.fetchStates(countryCode)
		}
	}

	@action
	setKeyword = () => {}

	@action
	checkExist = async () => {}

	@action
	reset = () => {
		this.states = []
		this.selectedCountry = null
		this.isLoading = false
	}
}

export { StateSearchStore }
